import { render, staticRenderFns } from "./OrganizationSelector.vue?vue&type=template&id=172d3c08&scoped=true&"
import script from "./OrganizationSelector.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d3c08",
  null
  
)

export default component.exports